import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { Volleyball, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#0A0A0A]">
      <form onSubmit={submit} className="w-full max-w-sm border border-white/10 bg-[#141518] p-8">
        <div className="flex items-center gap-2 mb-6">
          <Volleyball className="w-6 h-6 text-[var(--gv-blue-bright)]" />
          <span className="font-display text-2xl">DAD JERZEYS ADMIN</span>
        </div>
        <input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email"
          className="w-full bg-black border border-white/10 focus:border-[var(--gv-blue)] outline-none px-4 py-3 text-sm mb-3" />
        <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password"
          className="w-full bg-black border border-white/10 focus:border-[var(--gv-blue)] outline-none px-4 py-3 text-sm mb-4" />
        <button type="submit" disabled={loading} data-testid="admin-login-btn"
          className="w-full flex items-center justify-center gap-2 bg-[var(--gv-blue)] hover:bg-[var(--gv-blue-bright)] text-black font-bold uppercase tracking-widest text-sm py-3 transition-colors disabled:opacity-50">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />} Sign In
        </button>
      </form>
    </div>
  );
}
